import { useSessionStore } from '../../session/store';

const SEBI_URL =
  'https://www.sebi.gov.in/reports-and-statistics/research/jan-2023/study-analysis-of-profit-and-loss-of-individual-traders-dealing-in-equity-fando-segment_67525.html';

export default function DisclaimerModal() {
  const disclaimerAccepted = useSessionStore((s) => s.disclaimerAccepted);
  const acceptDisclaimer = useSessionStore((s) => s.acceptDisclaimer);
  const token = useSessionStore((s) => s.token);
  const ready = useSessionStore((s) => s.ready);
  const role = useSessionStore((s) => s.role);
  const isSuperAdmin = useSessionStore((s) => s.isSuperAdmin);

  if (!ready || !token || disclaimerAccepted || role === 'admin' || isSuperAdmin) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <div className="bg-bg-panel border border-bg-border rounded-xl shadow-modal max-w-4xl w-full max-h-[74vh] flex flex-col">
        {/* Header */}
        <div className="px-6 py-4 border-b border-bg-border text-center shrink-0">
          <h2 className="text-base font-display font-bold text-txt-primary uppercase tracking-wide">
            Risk Disclosures on Derivatives
          </h2>
        </div>

        {/* Body */}
        <div className="flex-1 overflow-y-auto px-6 py-5 space-y-4 text-xs text-txt-secondary leading-relaxed">
          <p>
            I, the undersigned subscriber of <strong className="text-txt-primary">ALGOSYS&reg;</strong>, affirm my
            acceptance of this declaration, granting authorization for semi-automatic trading. I acknowledge the
            comprehended risks and the potential for unforeseen technological issues leading to losses beyond my
            expectations.
          </p>

          <p>
            Taking full responsibility for my replica trading, guided by automated signals from the Strategy Owner, I
            explicitly declare ALGOSYS&reg; empowerment for semi-automatic trade execution. Recognizing that the Strategy
            Owner may or may not be a SEBI registered advisor, I assume sole responsibility for subscribing to their
            services via ALGOSYS&reg; for educational knowledge sharing.
          </p>

          <p>
            Prior to initiating trading based on the educational knowledge shared, I have diligently performed due
            diligence and consulted my financial advisor. The information displayed in my trading account is replicated
            for my use, and I acknowledge that ALGOSYS&reg; administration does not store this data, ensuring privacy.
          </p>

          <p>
            In consideration, I absolve and indemnify the Strategy Owner, as well as the ALGOSYS&reg; creator and
            execution team, from any profits or losses arising from system utilization.
          </p>

          <p className="font-semibold text-txt-primary">
            Furthermore, in understanding the risk disclosures in the Equity Futures &amp; Options segment:
          </p>

          <ul className="list-disc list-inside space-y-1.5 pl-2">
            <li>
              <strong>High Incidence of Net Losses:</strong> 9 out of 10 individual traders in equity Futures and Options
              Segment, incurred net losses.
            </li>
            <li>
              <strong>Average Net Trading Losses:</strong> On average, loss makers registered net trading loss close to
              Rs. 50,000.
            </li>
            <li>
              <strong>Additional Transaction Costs for Loss Makers:</strong> Over and above the net trading losses
              incurred, loss makers expended an additional 28% of net trading losses as transaction costs.
            </li>
            <li>
              <strong>Transaction Costs for Net Profit Earners:</strong> Those making net trading profits, incurred
              between 15% to 50% of such profits as transaction cost.
            </li>
          </ul>

          <p className="text-2xs text-txt-muted">
            Source:{' '}
            <a
              href={SEBI_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-info underline hover:text-info/80"
            >
              SEBI study
            </a>{' '}
            dated January 25, 2023 on &ldquo;Analysis of Profit and Loss of Individual Traders dealing in equity Futures
            and Options (F&amp;O) Segment&rdquo;, wherein Aggregate Level findings are based on annual Profit/Loss
            incurred by individual traders in equity F&amp;O during FY 2021-22.
          </p>

          <p>
            Acknowledging these risk disclosures signifies my understanding of the challenges in trading Equity Futures
            &amp; Options. This reaffirms my commitment to due diligence and responsibility in my trading activities,
            including those conducted through ALGOSYS&reg;.
          </p>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-bg-border shrink-0 flex flex-col items-center gap-3">
          <label className="flex items-start gap-2 text-xs text-txt-secondary cursor-pointer">
            <span>* I understand the risks associated with derivative trading.</span>
          </label>
          <button
            onClick={acceptDisclaimer}
            className="btn-primary px-8 py-2.5 text-sm font-semibold"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
